import React, { Component } from 'react';
import { connect } from 'react-redux';
import AdjustInventoryDialog from './AdjustInventoryDialog';
import TransferProductDialog from './TransferProductDialog';
import JointProductsList from './JointProductsList';
import BulkToUnitDialog from './BulkToUnitDialog'
import LOOKUP from 'constants/lookup';
import { POReasons } from 'constants/enums';
import { transferListCrumb } from 'utils/breadcrumbInfo';
import { mapWarehouseCard } from 'utils/mappers';
import {
    getProductTypes, WpInventorySyncronization, lookupUnmappedProducts, getWarehouses, clearSelectAdjustmentProduct, clearWarehouses, clearOnHoldQty, getProductsGroupedFromWarehouse, setSelectAdjustmentProduct, sendTransferProduct, sendBulkToUnitProduct, transferProductToWarehouse,
    getProductByBarcode, clearProductTypeList, clearProductWarehousesList
} from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getCsvReport } from 'actions/ReportsAction';
import { showError } from 'actions/CommonActions';
import BarcodeReader from 'library/readBarcode';
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import SearchFields from './components/searchFields';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import CheckInput from 'screens/components/basic/CheckInput';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

const customContentStyle = {
    width: '80%',
    maxWidth: 'none',
    height: '60%'
};

class TransferProductPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            dialogAdjustment: true,
            openTransfer: false,
            openAdjust: false,
            openBulkToUnit: false,
            openTransferProduct: false,
            productJoin: null,
            dialogJointProduct: false,
            showExportCSVDialog: false,
            warehouse: {
                pagination: {
                    activePage: 1,
                    itemsPerPage: 20
                },
                filter: {
                    warehouseId: null,
                    productName: "",
                    skuNumber: "",
                    categoryId: null,
                    quantity: null,
                    orderBy: 'DESC',
                    sortBy: '',
                    branchId: this.props.branchId || 1,
                    productBrand: ""
                }
            }

        };

        this.amounts = [];
        this.toWarehouse = [];
        this.getProductsGrouped = this.getProductsGrouped.bind(this);
        this.handleTransferDialog = this.handleTransferDialog.bind(this);
        this.handleTransferProductDialog = this.handleTransferProductDialog.bind(this);
        this.handleBulkToUnitDialog = this.handleBulkToUnitDialog.bind(this);
        this.handleAdjustDialog = this.handleAdjustDialog.bind(this);
        this.convertToJoint = this.convertToJoint.bind(this);
        this.adjustProduct = this.adjustProduct.bind(this);
        this.closeDialogAdjustment = this.closeDialogAdjustment.bind(this);
        this.validateTableComponents = this.validateTableComponents.bind(this);
        this.transferSingleProduct = this.transferSingleProduct.bind(this);
        this.closeDialogJointProducts = this.closeDialogJointProducts.bind(this);
        this.closeDialogBulkToUnit = this.closeDialogBulkToUnit.bind(this);
        this.bulkToUnitProduct = this.bulkToUnitProduct.bind(this);

        this.barcodeReader = new BarcodeReader();
    }

    componentWillMount() {
        this.props.getWarehouses(this.props.branchId);
        this.props.getProductTypes();
        this.getProductsGrouped();
    }

    componentDidMount() {
        window.addEventListener("keypress", this.barcodeListener);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.scannedTime !== newProps.scannedTime && newProps.scannedTime != null && newProps.scannedTime != undefined) {
            this.getProductsGrouped(newProps.productScan.name);
        }

        if (newProps.barcodeNotFound && newProps.barcodeNotFound != this.props.barcodeNotFound) {
            this.props.showError("Product was not found. Check if the product is available.");
        }
    }

    componentWillUnmount = () => {
        this.props.clearWarehouses();
        window.removeEventListener("keypress", this.barcodeListener);
        this.props.clearProductTypeList();
        this.props.clearProductWarehousesList();
    }

    barcodeListener = () => {
        if (document.activeElement.tagName != "INPUT") {
            this.barcodeReader.listening(this.getProductByBarcode)
        }
    }

    getProductByBarcode = (barcode) => {
        this.props.getProductByBarcode(barcode, this.props.branchId);
    }

    handleTransferDialog() {
        this.setState(prevState => {
            return {
                ...prevState,
                openTransfer: !prevState.openTransfer
            }
        });
    }

    handleTransferProductDialog() {
        this.setState(prevState => {
            return {
                ...prevState,
                openTransferProduct: !prevState.openTransferProduct
            }
        });
    }

    handleAdjustDialog() {
        this.setState(prevState => {
            return {
                ...prevState,
                openAdjust: !prevState.openAdjust
            }
        });
    }

    handleBulkToUnitDialog() {
        this.setState(prevState => {
            return {
                ...prevState,
                openBulkToUnit: !prevState.openBulkToUnit
            }
        });
    }

    changePage = e => {
        this.setState(pState => {
            return {
                ...pState,
                warehouse: {
                    ...pState.warehouse,
                    pagination: {
                        ...pState.warehouse.pagination,
                        activePage: e
                    }
                }
            };
        }, this.getProductsGrouped);
    }

    closeDialogAdjustment = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                openAdjust: false
            }
        }, () => this.props.clearSelectAdjustmentProduct());
    }

    closeDialogTransfer = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                openTransferProduct: false
            }
        });
    }

    closeDialogBulkToUnit = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                openBulkToUnit: false
            }
        });
    }

    getProductsGrouped(scannedProductName) {
        const { activePage, itemsPerPage } = this.state.warehouse.pagination;
        const { warehouseId, productName, skuNumber, categoryId, quantity, orderBy, sortBy, branchId, productBrand } = this.state.warehouse.filter;
        const { categoryFilter, productNameFilter, skuNumberFilter, quantityFilter, warehouseFilter, productBrandFilter, productSpecieFilter, onHold } = this.props;
        let warehouseIdToUse = (warehouseFilter || warehouseId) > 0 ? parseInt(warehouseFilter || warehouseId) : null;
        let quantityToUse = quantityFilter || quantity;

        if (quantityToUse > 0 && warehouseIdToUse == null) {
            alert("You must select a specific warehouse (Storage, Store or Damage) when you want to filter by 'Quantity less than'.");
            return;
        }

        const model = {
            page: activePage,
            itemsPerPage: itemsPerPage,
            warehouseId: warehouseIdToUse,
            productName: scannedProductName || productNameFilter || productName,
            productSKU: skuNumberFilter || skuNumber,
            categoryId: (categoryFilter || categoryId) > 0 ? parseInt(categoryFilter || categoryId) : null,
            quantity: quantityToUse,
            orderBy: orderBy,
            sortBy: sortBy,
            branchId: branchId || 1,
            productId: 0,
            productBrand: productBrandFilter || productBrand,
            productSpecies: ~~productSpecieFilter,
            onHold: onHold
        }
        this.props.getProductsGrouped(model);
    }

    search = () => {
        this.setState(pState => {
            return {
                ...pState,
                warehouse: {
                    ...pState.warehouse,
                    pagination: {
                        ...pState.warehouse.pagination,
                        activePage: 1
                    }
                }
            };
        }, this.getProductsGrouped);
    }

    cleanSearch = () => {
        this.props.clearFormInput('transferListCategory');
        this.props.clearFormInput('transferListCategoryText');
        this.props.clearFormInput('transferListNameFilter');
        this.props.clearFormInput('transferListSkuNumberFilter');
        this.props.clearFormInput('transferListQuantity');
        this.props.clearFormInput('transferListWarehouse');
        this.props.clearFormInput('transferListWarehouseText');
        this.props.clearFormInput('transferListBrand');
        this.props.clearFormInput('transferListBrandText');
        this.props.clearFormInput('transferListSpecies');
        this.props.clearFormInput('transferListSpeciesText');

        this.setState(pState => {
            return {
                ...pState,
                warehouse: {
                    ...pState.warehouse,
                    filter: {
                        warehouseId: null,
                        productName: "",
                        skuNumber: "",
                        categoryId: null,
                        quantity: null,
                        orderBy: 'DESC',
                        sortBy: '',
                        branchId: this.props.branchId || 1,
                        productBrand: "",
                        productSpecie: null
                    }
                }
            };
        }, this.getProductsGrouped);
    }

    cleanOnHold = () => {
        let model = {
            ProductId: 0,
            branchId: this.props.branchId
        };
        this.props.clearOnHoldQty(model);
    }

    adjustProduct = (product) => {
        this.setState(prevState => {
            return {
                ...prevState,
                openAdjust: true
            }
        }, () => this.props.setSelectAdjustmentProduct(product));
    }

    WpInventorySync = () => {
        let branchId = this.props.branchId;
        this.props.WpInventorySyncronization({ branchId });
    }

    lookupUnmappedProducts = () => {
        let branchId = this.props.branchId;
        this.props.lookupUnmappedProducts({ branchId });
    }

    transferProduct = (product) => {
        this.setState(prevState => {
            return {
                ...prevState,
                openTransferProduct: true
            }
        }, () => this.props.sendTransferProduct(product));
    }

    bulkToUnitProduct = (product) => {
        this.setState(prevState => {
            return {
                ...prevState,
                openBulkToUnit: true
            }
        }, () => this.props.sendTransferProduct(product));
    }

    clearOnHoldQty = (product) => {
        let model = {
            ProductId: product.productId,
            branchId: this.props.branchId
        };
        this.props.clearOnHoldQty(model);
    }

    convertToJoint = (product) => {
        this.setState(prevState => {
            return {
                ...prevState,
                productJoin: product

            }
        }, () => this.openDialogJointProducts());
    }

    openDialogJointProducts = () => {
        this.setState({ dialogJointProduct: true });
    }

    closeDialogJointProducts = () => {
        this.setState({ dialogJointProduct: false });
    }

    transferSingleProduct = (product, index) => {
        const quantity = this.amounts[index].stateProps.value;
        const toWarehouse = this.toWarehouse[index].stateProps.value;
        const quantityRounded = (product.isUnitProduct) ? parseInt(quantity) : parseFloat(quantity).toFixed(1);

        let reason = POReasons.Transfer;
        if (quantityRounded && toWarehouse) {
            if (toWarehouse === 3) {
                reason = POReasons.Lost; // Could be Lost Or OtherReduction
            }
            this.props.transferProductToWHS(product.productId, product.warehouseId, toWarehouse, quantityRounded, this.props.branchId, product.packageReference, reason);

            this.props.clearFormInput(`SingleTransfer${product.productId}-${product.warehouseId}-${product.packageReference}Amount`);
            this.props.clearFormInput(`SingleTransfer${product.productId}-${product.warehouseId}-${product.packageReference}ToWarehouse`);

        }
        else {
            this.props.showError("Please, type a right amount and select the warehouse");
        }
    }

    validateTableComponents = (event, product) => {
        let p = Math.max(0, parseFloat(event.target.value)).toString().slice(0, 7);
        if (p <= product.quantity) {
            event.target.value = p;
        } else if (p > product.quantity) {
            event.target.value = product.quantity;
        } else {
            event.target.value = p;
        }
    }

    showExportDialog = () => {
        this.setState({
            showExportCSVDialog: true
        })
    }

    closeExportDialog = () => {
        this.setState({
            showExportCSVDialog: false
        })
    }

    exportWarehouse = () => {
        this.closeExportDialog();
        const { warehouseId, productName, skuNumber, categoryId, quantity, branchId } = this.state.warehouse.filter;
        const { categoryFilter, productNameFilter, skuNumberFilter, quantityFilter, warehouseFilter, transferListZeroQuantity, transferListInventoryLevel, transferListGroupByLotNumber } = this.props;
        this.props.getCsvReport(`reports/excel/getCurrentInventory?branchId=${branchId}&productName=${productNameFilter || productName}&sku=${skuNumberFilter || skuNumber}&categoryId=${((categoryFilter || categoryId) > 0 ? parseInt(categoryFilter || categoryId) : null) > 0 ? parseInt(categoryFilter) : null}&quantityLessThan=${quantityFilter || quantity}&warehouseId=${(warehouseFilter || warehouseId) > 0 ? parseInt(warehouseFilter || warehouseId) : null}&exportZeroQuantity=${transferListZeroQuantity ? transferListZeroQuantity : false}&exportInventoryLevel=${transferListInventoryLevel ? transferListInventoryLevel : false}&groupByLotNumber=${transferListGroupByLotNumber ? transferListGroupByLotNumber : false}`, "CurrentInventoryReport");
    }


    render() {
        const p = this.props;
        const { activePage, itemsPerPage } = this.state.warehouse.pagination;
        const { productsWarehouses, warehouses, pageName } = p;
        let categories = [];
        categories.push({ text: "All", value: "0" });
        const cat = p.productTypes.length > 0 ? p.productTypes[0].categories : [];
        cat.map(item => {
            categories.push({
                text: item.name,
                value: item.id.toString()
            });
        });

        categories.sort((a, b) => {
            if (a.text < b.text)
                return -1;
            if (a.text > b.text)
                return 1;
            return 0;
        });

        const cannabisSpecies = LOOKUP.speciesWithAll;

        const onHoldOptions = [
            { text: 'All', value: "0" },
            { text: 'On Hold', value: "1" },
            { text: 'Not On Hold', value: "2" }
        ]

        return (
            <Grid headerContent={transferListCrumb}>
                <PageHeaderWithButton title={LOOKUP.menu.inventory.items.transferProduct.text}>
                <Button
                                className="bg-light-green"
                                type="DownloadButton"
                                id="exportToCSV"
                                label={"Export to CSV"}
                                onTouchTap={this.showExportDialog}
                            />
                            {p.wordpressEnabled ? <Button
                                className="bg-light-green"
                                type="WpUploadButton"
                                label={"WP Inventory Sync"}
                                onTouchTap={this.WpInventorySync}
                            /> : ""}
                            {p.wordpressEnabled ? <Button
                                className="bg-light-green"
                                type="LookupUnmappedProducts"
                                label={"Look Up Un-mapped WP products"}
                                onTouchTap={this.lookupUnmappedProducts}
                            /> : ""}
                </PageHeaderWithButton>
                <CardSimple>
                    <SearchFields
                        pageName={pageName}
                        warehouses={warehouses}
                        categories={categories}
                        species={cannabisSpecies}
                        onHold={onHoldOptions}
                        cleanSearch={this.cleanSearch}
                        search={this.search}
                        cleanOnHold={this.cleanOnHold}
                        isVape={p.isVape}
                    />
                </CardSimple>
                <CardSimple>
                    {/* RIGHT PANEL */}
                    <GenericTable
                        compName="warehouseStockListTable"
                        className="table_center tableHeaderwhiteColorFont"
                        tableBodyClassName="patients-table"
                        columns={LOOKUP.transferProduct.tableColumnsWarehouseCard}
                        rows={mapWarehouseCard(productsWarehouses.list,
                            this.adjustProduct,
                            this.convertToJoint,
                            this.transferProduct,
                            this.bulkToUnitProduct,
                            p.isMedical,
                            this.clearOnHoldQty,
                            p.isInspired ? p.canViewTransferAdjust : true )}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        multiSelectable={false}
                        enableSelectAll={false}
                        selectable={false}
                        stripedRows={true}
                    />
                    <Pagination
                        length={productsWarehouses.total}
                        itemsPerPage={itemsPerPage}
                        activePage={activePage}
                        onPageChange={this.changePage}
                        maxButtons={4}
                    />
                </CardSimple>

                {this.state.openAdjust ? <AdjustInventoryDialog name="adjustmentInventoryDialog" onClose={this.closeDialogAdjustment} placeOfInventoryChange={"6"} /> : ''}

                {this.state.openTransferProduct ? <TransferProductDialog name="transferProductDialog" onClose={this.closeDialogTransfer} /> : ''}

                {this.state.openBulkToUnit ? <BulkToUnitDialog name="bulkToUnitDialog" onClose={this.closeDialogBulkToUnit} /> : ''}

                {this.state.dialogJointProduct && (
                    <DialogInput
                        title="Roller Joint"
                        modal={true}
                        open={this.state.dialogJointProduct}
                        autoScrollBodyContent={true}
                        handleClose={this.closeDialogJointProducts}
                        contentStyle={customContentStyle}>
                        <br />
                        <JointProductsList
                            name={`JointProducts`}
                            selectedProducts={this.state.productJoin ? [this.state.productJoin] : []}
                            onCancel={() => this.closeDialogJointProducts()}
                            selectedRows={p.selectedRows} />
                    </DialogInput>
                )}
                {
                    this.state.showExportCSVDialog && (
                        <DialogInput
                            title={<DialogHeaderWithClose text="Export to CSV" handleClose={this.closeExportDialog} />}
                            modal={true}
                            open={this.state.showExportCSVDialog}
                            autoScrollBodyContent={true}
                            handleClose={this.closeExportDialog}
                            contentStyle={customContentStyle}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="col-lg-4 mt-2">
                                        <h4 className="font-weight-light"> Options for export: </h4>
                                    </div>
                                    <br />
                                    <div className="col-lg-8 inline-checkbox-btns">
                                        <CheckInput name={pageName + "ZeroQuantity"}
                                            key={"ZeroQuantity"}
                                            text={"Export Sold Out Products"}
                                            id="checkExportSoldOut"
                                            value={"ZeroQuantity"}
                                            className="checkBoxLabels" />
                                        <CheckInput name={pageName + "InventoryLevel"}
                                            key={"InventoryLevel"}
                                            text={"Export Inventory Level"}
                                            id="checkExportInventoryLevel"
                                            value={"InventoryLevel"}
                                            className="checkBoxLabels" />
                                        <CheckInput name={pageName + "GroupByLotNumber"}
                                            key={"GroupByLotNumber"}
                                            text={"Group by both product and lot number (if not select, will only group by product)"}
                                            id="checkGroupyProductAndLot"
                                            value={"GroupByLotNumber"}
                                            className="checkBoxLabels" />
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-lg-12">
                                    <Button
                                        name="trasferJointButton"
                                        className="pull-right"
                                        label="Export"
                                        primary={true}
                                        onTouchTap={() => this.exportWarehouse()} />
                                    <Button
                                        name="buttonCancel"
                                        type="Button"
                                        className="corner_X"
                                        onTouchTap={() => this.closeExportDialog()} />
                                </div>
                            </div>
                        </DialogInput>
                    )
                }
            </Grid>
        );
    }
}

function mapStatetoProps(state) {
    return {
        branchId: state.common.branchId,
        warehouses: state.entity.warehouses || [],
        productsWarehouses: state.entity.productsWarehouses,
        productTypes: state.entity.productTypesList,
        pageName: 'transferList',
        wordpressEnabled: state.common.applicationSettings.wordpressEnabled,
        categoryFilter: state.form.transferListCategory,
        productNameFilter: state.form.transferListNameFilter,
        skuNumberFilter: state.form.transferListSkuNumberFilter,
        quantityFilter: state.form.transferListQuantity,
        warehouseFilter: state.form.transferListWarehouse,
        productBrandFilter: state.form.transferListBrand,
        productSpecieFilter: state.form.transferListSpecies,
        onHold: state.form.transferListOnHold,
        transferListZeroQuantity: state.form.transferListZeroQuantity,
        transferListInventoryLevel: state.form.transferListInventoryLevel,
        transferListGroupByLotNumber: state.form.transferListGroupByLotNumber,
        selectedRows: state.form["warehouseStockListTableSelectedRows"] || [],
        isMedical: state.common.applicationSettings.isMedical,
        isVape: state.common.applicationSettings.isVape,
        productScan: state.entity.productDetail,
        scannedTime: state.entity.scannedTime,
        barcodeNotFound: state.entity.barcodeNotFound,
        canViewTransferAdjust: state.common.authenticatedUser && state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanViewTransferAdjust")),
        isInspired: state.common.applicationSettings.isInspired
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getWarehouses: (branchId) => dispatch(getWarehouses(branchId)),
        getProductTypes: () => dispatch(getProductTypes()),
        clearSelectAdjustmentProduct: () => dispatch(clearSelectAdjustmentProduct()),
        clearWarehouses: () => dispatch(clearWarehouses()),
        clearOnHoldQty: (model) => dispatch(clearOnHoldQty(model)),
        getProductsGrouped: (model) => dispatch(getProductsGroupedFromWarehouse(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        setSelectAdjustmentProduct: (product) => dispatch(setSelectAdjustmentProduct(product)),
        sendTransferProduct: (product) => dispatch(sendTransferProduct(product)),
        sendBulkToUnitProduct: (product) => dispatch(sendBulkToUnitProduct(product)),
        transferProductToWHS: (productID, fromWarehouse, toWarehouse, quantity, branchId, packageReference, reason) => dispatch(transferProductToWarehouse(productID, fromWarehouse, toWarehouse, quantity, branchId, packageReference, reason)),
        WpInventorySyncronization: (branchId) => dispatch(WpInventorySyncronization(branchId)),
        lookupUnmappedProducts: (branchId) => dispatch(lookupUnmappedProducts(branchId)),
        getProductByBarcode: (barcode, branchId) => dispatch(getProductByBarcode(barcode, branchId)),
        clearProductTypeList: () => dispatch(clearProductTypeList()),
        clearProductWarehousesList: () => dispatch(clearProductWarehousesList()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(TransferProductPage);
